import { Controller } from "@hotwired/stimulus";

// Formulário de filtros que se envia sozinho: selects e datas na hora, texto depois de uma pausa
// na digitação. Campos vazios saem da URL, e um envio igual ao anterior não sai de novo (o
// `change` do campo de texto ao perder o foco repetiria a busca que o `input` já fez).
export default class extends Controller {
  static values = { delay: { type: Number, default: 350 } };

  connect() {
    this.prune = (event) => {
      for (const [key, value] of [...event.formData.entries()]) {
        if (value === "") event.formData.delete(key);
      }
    };
    this.element.addEventListener("formdata", this.prune);
    this.last = this.serialize();
  }

  disconnect() {
    clearTimeout(this.timer);
    this.element.removeEventListener("formdata", this.prune);
  }

  submit() {
    clearTimeout(this.timer);
    const current = this.serialize();
    if (current === this.last) return;

    this.last = current;
    this.element.requestSubmit();
  }

  debounced() {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.submit(), this.delayValue);
  }

  serialize() {
    return new URLSearchParams(new FormData(this.element)).toString();
  }
}
